import React, { useEffect } from "react";
import StablePrime from "../components/Tables/StablePrime";
import { useLocation } from "react-router-dom";
import queryString from "query-string";

function StablePreview({ setPageHeader, urlData }) {
  const { search } = useLocation();
  const searchParams = queryString.parse(search);

  useEffect(() => {
    setPageHeader("Stable Preview");

  }, [])

  return (
    <div>
      <StablePrime url="stable/preview" data={{ ...searchParams, ...urlData }} identity="perfparam" />
    </div>
  );
}

export default StablePreview;
